import { useEffect, useState } from 'react';

export type GoogleAdsCompany = 'hales' | 'myccs' | 'abraham';

export const GOOGLE_ADS_COMPANY_OPTIONS: Array<{ value: GoogleAdsCompany; label: string }> = [
  { value: 'hales', label: "Hale's AC" },
  { value: 'myccs', label: 'Climate Control (myccs)' },
  { value: 'abraham', label: 'Abraham A/C' },
];

export function useGoogleAdsCompany(defaultCompany: GoogleAdsCompany = 'hales') {
  const [company, setCompany] = useState<GoogleAdsCompany>(defaultCompany);

  useEffect(() => {
    const stored = localStorage.getItem('googleAdsCompany');
    if (stored === 'hales' || stored === 'myccs' || stored === 'abraham') {
      setCompany(stored as GoogleAdsCompany);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('googleAdsCompany', company);
  }, [company]);

  return { company, setCompany };
}
